import { Expose } from 'class-transformer';

export class AppointmentCancelTypeStatusDto {
  @Expose()
  uuid: string;

  @Expose()
  title: string;
}
